import { JSX } from 'react';
import { AlertCircle, CheckCircle2, Loader2 } from 'lucide-react';

import { useApiStatus } from '../hooks/useApiStatus';

interface ApiStatusProps {
  /** Icon/status-dot only, label hidden — the 68px sidebar rail (title carries the same text). */
  compact?: boolean;
}

export function ApiStatus({ compact = false }: ApiStatusProps): JSX.Element {
  const { data: isOnline, isError, isLoading } = useApiStatus();

  if (isLoading) {
    return (
      <div
        className="flex items-center gap-2 text-muted"
        title={compact ? 'Checking API...' : undefined}
      >
        <Loader2 className="w-4 h-4 animate-spin" />
        {!compact && <span className="text-sm">Checking API...</span>}
      </div>
    );
  }

  if (isError || !isOnline) {
    return (
      <div className="flex items-center gap-2 text-error dark:text-error" title="API is offline">
        <AlertCircle className="w-4 h-4" />
        {!compact && <span className="text-sm">API Offline</span>}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-success dark:text-success" title="API is online">
      <CheckCircle2 className="w-4 h-4" />
      {!compact && <span className="text-sm">API Online</span>}
    </div>
  );
}
